export const chipsBurned = {
	byEmployee: {
		label: "Fichas quemadas por empleado",
		sheetFileName: "fichas-quemadas-empleado",
	},
	label: "Total de fichas quemadas",
	sheetFileName: "total-fichas-quemadas",
	since: "Desde",
	until: "Hasta",
	loading: "Generando hoja de cálculo",
	columns: {
		employee: "Empleado",
		name: "Nombre",
		product: "Producto",
		count: "Cantidad",
		unitaryCount: "Cantidad Unit.",
		fracionalCount: {
			label: "Cantidad Frac.",
			grams: "gramos",
			kg: "Kilos",
			lt: "Litros",
		},
		unitaryValue: "Valor unitario",
		subtotal: "Subtotal",
		discount: "Descuentos",
		totalValue: "Total",
		type: "Tipo",
	},
	total: "TOTAL",
	totalItem: "Total",
	mountableModal: {
		name: "Nombre",
		section: "Sección Compuesta",
		count: "Cantidad",
	},
	mountables: {
		label: "Compuestos",
		fiscalCode: "SKU",
		product: "Producto",
		category: "Categoría Producto",
		section: "Etapa Compuesta",
		name: "Item Compuesto",
		count: "Cantidad",
	},
};
